export const googleAutocomplete = {
    methods: {
        autoCompleteStreetAddress(_this, containerSelector, inputSelector, form, countries, states) {
            setTimeout(() => {
                $(containerSelector).each(() => {
                    const localityInput = document.getElementById(inputSelector);
                    const localityOptions = { types: ['address'], componentRestrictions: { country: 'us' } };
                    const places = new google.maps.places.Autocomplete(localityInput, localityOptions);

                    places.addListener('place_changed',  () => {
                        let place = places.getPlace();
                        let address = place.formatted_address;
                        let value = address.split(",");

                        let count = value.length;
                        let country = value[count - 1];
                        let state = value[count - 2];
                        let city = value[count - 3];
                        let street = value[count - 4];
                        let z = state.split(" ");

                        if (country.trim() === 'USA') {
                            country = 'US'
                        }

                        let matchedCountry = countries.find(el => {
                            return country.includes(el.code)
                        });
                        let matchedState = states.find(el => {
                            return z[1].includes(el.code)
                        });

                        if (form === 'billing') {
                            _this[form].billing_street = street;
                            _this[form].billing_country_id = matchedCountry.id;
                            _this[form].billing_city = city.trim();
                            _this[form].billing_state_id = matchedState.id;
                            _this[form].billing_zip_code = z[2];
                        }

                        if (form === 'companyInfoForm') {
                            _this[form].address = street;
                            _this[form].country_id = matchedCountry.id;
                            _this[form].city = city.trim();
                            _this[form].state_id = matchedState.id;
                            _this[form].zip_code = z[2];
                        }
                    });
                })
            }, 500);
        },
    }
}
